import { render, staticRenderFns } from "./ReceiveEdit_Details.vue?vue&type=template&id=200301df&"
import script from "./ReceiveEdit_Details.vue?vue&type=script&lang=js&"
export * from "./ReceiveEdit_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports